import { createFileRoute } from '@tanstack/react-router'
import { requireAccess } from '../../../app/guards'
import { taxRatesQueryOptions } from '../../../features/finance/queries'
import { PURCHASING_ACCESS } from '../../../features/purchasing/access'
import { NewPurchasePage } from '../../../features/purchasing/purchase-pages'
import { newPurchaseSearchSchema } from '../../../features/purchasing/search'
import { salesSettingsQueryOptions } from '../../../features/sales/queries'

export const Route = createFileRoute('/_app/purchases/new')({
  staticData: { crumb: 'purchaseNew' },
  validateSearch: newPurchaseSearchSchema,
  beforeLoad: ({ context }) => requireAccess(context.session, PURCHASING_ACCESS.purchase),
  loader: async ({ context }) => {
    // The tax mode prices the lines; the rates give the first line its default tax.
    await Promise.all([
      context.queryClient.ensureQueryData(salesSettingsQueryOptions),
      context.queryClient.ensureQueryData(taxRatesQueryOptions),
    ])
  },
  component: NewPurchasePage,
})
